import { theme } from '@chakra-ui/theme';

export const CHECKBOX_PARTS = theme.components.Checkbox.parts;
